import Pdf1 from '@/assets/media/pdf1.pdf';
import Pdf2 from '@/assets/media/pdf2.pdf';
import { ReactComponent as IconCopy } from '@/assets/svgs/copy.svg';
import { ReactComponent as IconPitstopBannerBackground } from '@/assets/svgs/icon-pitstop-banner-backgroud.svg';
import { ReactComponent as IconPitStop } from '@/assets/svgs/Pitstop-grey.svg';
import Button from '@/components/Button/index';
import IconEye from '@/components/IconEye';
import Portal from '@/components/Portal';
import Tabs, { Tab } from '@/components/Tabs';
import Toast from '@/components/Toast';
import usePage from '@/hooks/use-page';
import usePitstop from '@/hooks/use-pitstop/index';
import useToast from '@/hooks/use-toast';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from '@/lib/router-dom';
import Tags from '@/componentsDS/Tags/Tags';
import Breadcrumbs from '@/componentsDS/Breadcrumbs/index';
import { useBuildex } from "@/hooks/use-buildex"

const Page = () => {

	/*=================================================1
		General
	/================================================*/
	const { goTo } = useNavigate();
	const [pageTitle, setPageTitle] = useState("Pitstops & Licenses");
	const isBuildex =useBuildex()

	const toastType = {
		success: "success",
		error: "error"
	}

	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [
			{
				label: '',
				link: `/`,
			},
			{
				label: pageTitle,
				link: ``
			},
		]
	})

	/*=================================================
		API
	/================================================*/

	const { toastList, addToastMessage } = useToast()

	const { items: pitstopItems, fetch: fetchPitstop, error: errorPitstop } = usePitstop()

	const [guides, setGuides] = useState([
		{
			fileName: 'Installation Guide.pdf',
			file: Pdf1
		},
		{
			fileName: 'Support Guide.pdf',
			file: Pdf2
		}
	])

	useEffect(() => {
		fetchPitstop()
	}, [])

	useEffect(() => {
		addToastMessage(errorPitstop, toastType.error)
	}, [errorPitstop])

	/*=================================================
		License Keys
	/================================================*/

	const CustomMaskInput = ({ item }) => {
		const [customMask, setCustomMask] = useState(true);

		return (
			<>
				<div className='license-keys--masked-item-input'>
					<input disabled value={item?.licensekey || ''} type={customMask ? 'password' : 'text'} />
				</div>

				<span data-testid="reveal-btn" className="link icon-eye-reveal" onClick={() => setCustomMask(!customMask)}>
					<IconEye bool={customMask} />
				</span>
			</>
		)
	}

	const LicenseCard = ({ item }) => {
		const [customMask, setCustomMask] = useState(true);

		const [tabsItems, setTabsItems] = useState([
			{ label: 'License Keys', active: true },
			//{ label: 'Guides', active: false },
		])

		function selectTab(index) {
			const tabs = [...tabsItems].map(item => ({ ...item, active: false }))

			tabs[index].active = true
			setTabsItems(tabs)
		}

		return (
			<div className='license-key-list-wrapper' >
				<div className='license-key-top-card'>
					<div className="license-card-left-info">
						<div className='license-key-title'>
							{item?.systemName}
						</div>
						{!isBuildex &&

							<div className='license-key-subtitle'>
								{
									item?.host === 'CDI' ? 'SGTradex Hosted' : 'Self'
								}
							</div>
						}
					</div>
					{
						!isBuildex &&
						<div className="license-card-right-icon"><IconPitstopBannerBackground /></div>
					}
				</div>

				<div className='license-key-content'>

					<div className='license-key-left-col--flex'>
						<div className='license-keys--flex'>
							<div className='license-key-input license-key-input--disabled'>
								<input name="api_key_value" type="text" readOnly value={item?.endPointUrl} />
							</div>

							<Button ghost text="Copy URL" submit={() => {
								navigator.clipboard.writeText(item?.endPointUrl)
							}} />

						</div>
						{item.host !== "CDI" && (
							<Button ghost text="Edit Pitstop" submit={() => gotoEditPitstop(item)} />
						)}
					</div>

					<div className='license-key-header'>
						<Tabs>
							{tabsItems.map((item, index) => (
								<Tab key={index} label={item.label} active={item.active} onClick={() => selectTab(index)} />
							))}
						</Tabs>
					</div>

					<div className="title-header__hr">
						<hr />
					</div>

					{
						(tabsItems[0].active) && (
							<>
								{
									item?.licenses?.map((dataItem, index) => {
										return (
											<div className='license-keys--cols' key={index}>
												<div className='license-keys--left-item'>
													<div className='license-keys--flex'>
														<div className='license-keys--item-label'>
															{dataItem?.mode}
														</div>
														<CustomMaskInput item={dataItem} />

													</div>
												</div>
												<div data-testid="copy-key-btn" className='license-keys--right-item link' onClick={() => navigator.clipboard.writeText(dataItem?.licensekey)}>
													<IconCopy />
												</div>
											</div>
										)
									})
								}
							</>
						)
					}
					{/* {
						(tabsItems[1].active) && (
							<>
								{
									guides?.map((dataItem, index) => {
										return (
											<div className='license-keys--cols license-keys-cols--guides' key={index}>
												<div className='license-keys--left-item'>
													<div className='license-keys--flex'>
														<div className='license-keys--item-label'>
															<a href={dataItem?.file} target="_blank" rel="noreferrer">{dataItem?.fileName}</a>
														</div>
													</div>
												</div>
											</div>
										)
									})
								}
							</>
						)
					} */}
				</div>
			</div>
		)
	}

	const LicenseKeyList = ({ itemData }) => {

		if ((!Array.isArray(itemData))) {
			return <></>
		}

		const list = itemData?.map((item, index) => {
			return (
				<Fragment key={index}>
					<LicenseCard item={item} />
				</Fragment>
			)
		})

		return (
			<>
				{
					list.length !== 0 ?
						list
						:
						<div className='pitstop-setup-banner' style={banner}>
							<div className='pitstop-icon'>
								<IconPitStop />
							</div>
							<div className='pitstop-label'>
								Set up your first pitstop
							</div>

							<Button text="Setup your pitstop" submit={() => goTo('/pitstop/configuration')} />
						</div>
				}
			</>
		)
	}

	/*=================================================
		Navigate
	/================================================*/

	function gotoEditPitstop(item) {
		goTo('/pitstop/configuration', { data: item, mode: 'edit' })
	}

	/*=================================================
		Additional Function
	/================================================*/

	// const cardStyles = {
	// 	backgroundImage: `url("../../pitstop-background.jpg")`
	// }

	const banner = {
		backgroundImage: `url("../../pitstop-banner.png")`
	}

	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />

			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">
						{pageTitle}
					</div>
				</div>
				<div className="title-header__right">
					<div className="overview__filter overview__button_wrap">
						<Button round full maxWidth={140} text="Create New Pitstop" id="create-new-pitstop-button" submit={() => goTo('/pitstop/configuration')} />
					</div>
				</div>
			</div>

			<hr />

			<div className="overview">
				<div className="overview__content">
					<LicenseKeyList itemData={pitstopItems} />
				</div>
			</div>

			<Toast toastList={toastList || []} />
		</>
	)

}

export default Page
